import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import { IconButton, lighten, Typography } from '@material-ui/core';
import { ChevronRight } from '@material-ui/icons';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
  },
  header: {
    display: 'flex',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    marginTop: theme.spacing(4),
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  headerLeft: {
    display: 'flex',
  },
  headerChevron: {
    color: theme.palette.facet.accentBlue,
  },
  children: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    flex: 1,
    overflowY: 'scroll',
  },
  blueTitle: {
    color: theme.palette.facet.primaryBlue,
  },
  blueBackground: {
    backgroundColor: theme.palette.facet.accentBlue5,
  },
  greenTitle: {
    color: theme.palette.facet.accentGreen,
  },
  greenBackground: {
    backgroundColor: lighten(theme.palette.facet.accentGreen2, 0.9),
  },
  actionIcon: {},
  footer: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
});

const LayoutItem = ({
  classes,
  className,
  title,
  children,
  variant,
  actionIcon,
  onActionClick,
  onChevronClick,
  FooterComponent,
  HeaderComponent,
}) => {
  return (
    <div className={classNames(classes.root, className)}>
      <div className={classes.header}>
        <div className={classes.headerLeft}>
          <Typography
            variant="h1"
            className={classNames({
              [classes.title]: true,
              [classes.blueTitle]: variant === 'blue',
              [classes.greenTitle]: variant === 'green',
            })}
          >{title}
          </Typography>
          <IconButton className={classes.headerChevron} onClick={onChevronClick}>
            <ChevronRight fontSize="small" />
          </IconButton>
        </div>
        {actionIcon && (
        <IconButton className={classes.actionIcon} onClick={onActionClick}>
          {actionIcon}
        </IconButton>)}
        {HeaderComponent}
      </div>
      <div className={classNames(classes.children, {
        [classes.blueBackground]: variant === 'blue',
        [classes.greenBackground]: variant === 'green',
      })}
      >
        {children}
      </div>
      <div className={classNames(classes.footer, {
        [classes.blueBackground]: variant === 'blue',
        [classes.greenBackground]: variant === 'green',
      })}
      >
        {FooterComponent}
      </div>
    </div>
  );
};

LayoutItem.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['blue', 'green']),
  actionIcon: PropTypes.node,
  onActionClick: PropTypes.func,
  onChevronClick: PropTypes.func.isRequired,
  FooterComponent: PropTypes.object,
  HeaderComponent: PropTypes.object,
};

LayoutItem.defaultProps = {
  className: '',
  variant: '',
  actionIcon: null,
  onActionClick: null,
  FooterComponent: null,
  HeaderComponent: null,
};

export default withStyles(styles)(LayoutItem);
